import { CatButton } from '@blocks-react/components/Button';
import { AddToCartBtnProps } from '../types';

export const AddToCartBtn = ({
  children,
  onClick,
  ...buttonProps
}: AddToCartBtnProps) => {
  return (
    <CatButton
      variant="primary"
      size="sm"
      fullWidth
      onClick={onClick}
      data-track-event="e_primaryCTA"
      data-track-attr-nltext="Add to Cart"
      {...buttonProps}
    >
      {children}
    </CatButton>
  );
};
